import type { InsertCauseMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertCauseDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { InsertCauseInput } from './types';

export const useInsertCause = createMutationHook({
  name: 'insertCause',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.cause.insert.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertCauseInput): InsertCauseInput => ({
    ParentIssueId: variables.ParentIssueId ?? '',
    Title: variables.Title ?? '',
    Description: variables.Description,
    Significance: variables.Significance,
    CustomAttributeData: variables.CustomAttributeData ?? null,
  }),
  invalidate: (trpc) => [
    trpc.frontend.cause.register.queryKey(),
    trpc.frontend.cause.getById.queryKey(),
    trpc.frontend.cause.getByParentIssueId.queryKey(),
    // COI-889: the left-nav badge reads this count family.
    trpc.frontend.cause.causeCount.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertCauseMutation => ({
    insert_cause: {
      __typename: 'cause_mutation_response',
      returning: [{ __typename: 'cause', Id: result.Id }],
    },
  }),
  graphqlDocument: InsertCauseDocument,
  graphqlVariables: (variables: InsertCauseInput) => ({
    ...variables,
  }),
  evictFields: ['cause', 'cause_aggregate'],
});
